import React, {useContext} from "react";
import {useForm, FormProvider} from "react-hook-form";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import * as CustomStyles from '../styles/CustomStyles';
import * as UserFragment from './UserFragmentComponent';
import * as Security from '../../utils/auth/Security';
import {TabPanel, a11yProps} from "../custom/CustomTabPanelComponent";
import BucketContext from "../context/BucketContext";



const TabBottomButtonBar = (props) => {
    return (
        <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            <React.Fragment>
                <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                    <Button variant="outlined" type="submit" sx={{ marginRight: 1 }}> {props.buttonLabel} </Button>
                </Grid>
            </React.Fragment>
        </Grid>
    );
}


function UserTabsRenderer(props) {
    console.log('User tab renderer');

    const bucketContext = useContext(BucketContext);

    const methods = useForm({
        defaultValues: {
            lUser: props.user
        } 
    });
    const handleSubmit = methods.handleSubmit;

    const userTabIndex = bucketContext.bucket.userTabIndex != null ? bucketContext.bucket.userTabIndex : 0;

    const [tabIndex, setTabIndex] = React.useState(userTabIndex);
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        bucketContext.setBucketValue({ userTabIndex: newValue });
    };

    const handleSubmitGeneralData = (data) => {
        const user = {
            id: data.lUser.id,
            generalSection: data.lUser.generalSection
        }
        props.saveUser(user, data.lUser.generalSection.clientId);
    }

    const handleSubmitAuthorizations = (data) => {
        const user = {
            id: data.lUser.id,
            autorizatie: data.lUser.autorizatie
        }
        console.log(JSON.stringify(user))
        props.saveUser(user, data.lUser.generalSection.clientId);
    }

    return (
        <React.Fragment>

            <FormProvider {...methods} >
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabIndex} onChange={handleTabChange} aria-label="scrollable tabs" variant="scrollable" scrollButtons="auto">
                            <Tab label="Date Generale" {...a11yProps(0)} />
                            <Tab label="Autorizatie" {...a11yProps(1)} />
                        </Tabs>
                    </Box>

                    <TabPanel value={tabIndex} index={0}>
                        <form onSubmit={handleSubmit(handleSubmitGeneralData)} id={'generalDataTabForm'}>
                            <UserFragment.RenderGeneralSection 
                                client={props.client}
                                employers={props.employers}
                                worksites={props.worksites}    
                            />

                            <TabBottomButtonBar
                                buttonLabel='Salveaza Date Generale'
                            />
                        </form>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={1}>
                        <form onSubmit={handleSubmit(handleSubmitAuthorizations)} id={'authorizationsTabForm'}>
                            <UserFragment.RenderAuthorizationsSection />
                            <TabBottomButtonBar
                                buttonLabel='Salveaza Autorizatie'
                            />
                        </form>
                    </TabPanel>
                </Box>
            </FormProvider>
        </React.Fragment>
    );
}

export default UserTabsRenderer